import { gql } from "@apollo/client";

export type CustomerUserError = {
  code: string;
  field: string[];
  message: string;
};

export const CUSTOMER_USER_ERROR_FRAGMENT = gql`
  fragment CustomerUserErrorFragment on CustomerUserError {
    code
    field
    message
  }
`;
